import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export const keys = createQueryKeySet<UseRefereeDutiesListQueryParams>('referee-duties');

type UseRefereeDutiesListQueryParams = Parameters<typeof SSF.api.judgeDutiesList>[0];

export function useRefereeDutiesListQuery(params: UseRefereeDutiesListQueryParams = {}, enabled = true) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.judgeDutiesList(params);
      return data;
    },
    queryKey: keys.list(params),
    enabled,
  });
}
